if (document.documentElement.lang.split('-')[0] === 'hu') {
(function(){
  function init(root){
    if(!root || root.dataset.pilotReady)return;
    root.dataset.pilotReady='true';
    const title=root.querySelector('.x-block-product-title');
    const media=root.querySelector('.product-media-container');
    if(title&&media){
      const home=document.createComment('Original product title position');title.before(home);
      const mobile=matchMedia('(max-width:767px)');
      const place=()=>{if(mobile.matches){media.before(title);title.classList.add('pb-igora-mobile-title');}else{home.after(title);title.classList.remove('pb-igora-mobile-title');}};
      mobile.addEventListener('change',place);place();
    }
    const set=root.querySelector('pb-cro-set');
    const layout=set?.querySelector('.pb-cro-set__layout');
    if(layout){
      const details=document.createElement('details');details.className='pb-igora-routine';
      const summary=document.createElement('summary');
      const label=document.createElement('span');label.textContent='Oxidálószer és kiegészítők hozzáadása';
      const hint=document.createElement('small');hint.textContent='Opcionális · minden kiválasztott termék egy kattintással';
      const compact=document.createElement('span');compact.className='pb-igora-routine-total';
      summary.append(label,hint,compact);details.append(summary);layout.before(details);details.append(layout);
      const total=set.querySelector('[data-set-grand-total]');
      const refresh=()=>{const value=total?.textContent;compact.textContent=value&&value!=='—'?'Kiválasztott termékek összesen: '+value:'';};
      if(total)new MutationObserver(refresh).observe(total,{childList:true,subtree:true,characterData:true});refresh();
    }
    const description=root.querySelector('.pb-cro-accordion');if(description)description.open=false;
    const range=root.querySelector('.pb-cro-range-products');
    if(range){
      range.querySelector('h2').textContent='Fedezd fel az IGORA termékcsaládot';
      const cards=[...range.querySelectorAll('.pb-cro-range-products__item')];cards.slice(4).forEach(e=>e.remove());
    }
  }
  const start=()=>document.querySelectorAll('.pb-igora-pilot').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();

} else {
(function(){
  function init(root){
    if(!root || root.dataset.pilotReady)return;
    root.dataset.pilotReady='true';
    const title=root.querySelector('.x-block-product-title');
    const media=root.querySelector('.product-media-container');
    if(title&&media){
      const home=document.createComment('Original product title position');title.before(home);
      const mobile=matchMedia('(max-width:767px)');
      const place=()=>{if(mobile.matches){media.before(title);title.classList.add('pb-igora-mobile-title');}else{home.after(title);title.classList.remove('pb-igora-mobile-title');}};
      mobile.addEventListener('change',place);place();
    }
    const set=root.querySelector('pb-cro-set');
    const layout=set?.querySelector('.pb-cro-set__layout');
    if(layout){
      const details=document.createElement('details');details.className='pb-igora-routine';
      const summary=document.createElement('summary');
      const label=document.createElement('span');label.textContent='Adaugă oxidant și accesorii';
      const hint=document.createElement('small');hint.textContent='Opțional · toate produsele alese, într-un singur click';
      const compact=document.createElement('span');compact.className='pb-igora-routine-total';
      summary.append(label,hint,compact);details.append(summary);layout.before(details);details.append(layout);
      const total=set.querySelector('[data-set-grand-total]');
      const refresh=()=>{const value=total?.textContent;compact.textContent=value&&value!=='—'?'Total selecție: '+value:'';};
      if(total)new MutationObserver(refresh).observe(total,{childList:true,subtree:true,characterData:true});refresh();
    }
    const description=root.querySelector('.pb-cro-accordion');if(description)description.open=false;
    const range=root.querySelector('.pb-cro-range-products');
    if(range){
      range.querySelector('h2').textContent='Explorează familia IGORA';
      const cards=[...range.querySelectorAll('.pb-cro-range-products__item')];cards.slice(4).forEach(e=>e.remove());
    }
  }
  const start=()=>document.querySelectorAll('.pb-igora-pilot').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();

}
